import React, { useState } from "react";
import { quote } from "../../config";
import { useWorkflowContext } from "../Workflow/WorkflowContextProvider";
import { useVariablesContext } from "../Workflow/WorkflowVariables/context/variableContext";
import { useFormChange } from "./contexts/FormChangeContext";
import { useFormMetadata } from "./contexts/FormMetadataContext";
import "./styles/FormBuilderFooter.scss";
import { createVariableDataObject, validateVariableConfiguration } from "./utils/variableValidation";

/**
 * Form Builder Footer Component
 * @author Sarthak Arora
 */
const FormBuilderFooter = ({
  onAddSubsection,
  onSave,
  onCancel,
  saveButtonText = "Save Form",
  isSaving = false,
  isEditable = true,
  onSaveVariables,
  onExpandAll,
  onCollapseAll,
  areAllExpanded,
  hasSubsections = false,
}) => {
  const { hasChanges } = useFormChange();
  const { formTitle } = useFormMetadata();
  const variablesContext = useVariablesContext();
  const workflowContext = useWorkflowContext();
  const { hasVarChanges, setHasVarChanges } = variablesContext;
  const [isSubmitting, setIsSubmitting] = useState(false);
  /**
   * Determines if the save button should be disabled
   * @author Abhishek Dhillon
   * @returns {boolean} True if the save button should be disabled
   */
  const getSaveButtonDisabledCondition = () => {
    return isSaving || isSubmitting || !hasChanges || !formTitle;
    // if (hasVarChanges) {
    //   // Different condition when there are variable changes
    //   return isSaving || isSubmitting || !hasVarChanges;
    // } else {
    //   // Default condition when no variable changes
    //   return isSaving || isSubmitting || !hasChanges || !formTitle;
    // }
  };

  /**
   * Handles form submission with variable validation
   * @author Abhishek Dhillon
   */
  const submitForm = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      // Validate variable configuration before saving
      // if (hasVarChanges) {
      //   const variableData = createVariableDataObject({
      //     ...variablesContext,
      //     ...workflowContext,
      //   });

      //   const isValidVariable = validateVariableConfiguration(variableData, setHasVarChanges);
      //   if (!isValidVariable) {
      //     setIsSubmitting(false);
      //     return; // Stop submission if validation fails
      //   }
      //   await onSaveVariables();
      //   setHasVarChanges(false);
      // }

      if (hasChanges) {
        await onSave();
      }
    } catch (error) {
      console.error("Error submitting form", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  /**
   * Handles expand/collapse all button click
   */
  const handleExpandCollapseAll = () => {
    if (areAllExpanded) {
      onCollapseAll();
    } else {
      onExpandAll();
    }
  };

  return (
    <div className='form-builder-footer'>
      <div className='footer-inner d-flex justify-content-between align-items-center'>
        <div className='footer-left-actions d-flex align-items-center'>
          <button className='btn add-subsection-btn' onClick={onAddSubsection} id='add-subsection-btn'>
            + Add Sub Section
          </button>
          {hasSubsections && (
            <button
              className='btn expand-collapse-btn btn-primary'
              onClick={handleExpandCollapseAll}
              id='expand-collapse-all-btn'
              title={areAllExpanded ? "Collapse all subsections" : "Expand all subsections"}>
              {areAllExpanded ? "Collapse All" : "Expand All"}
            </button>
          )}
        </div>
        <div className='footer-actions'>
          <button className='btn btn-ghost' onClick={onCancel} id='cancel-form-btn'>
            Close
          </button>
          <button
            className='btn btn-primary'
            onClick={submitForm}
            disabled={getSaveButtonDisabledCondition()}
            title='Save Form (Ctrl+S)'
            id='save-form-btn'>
            {isSaving ? "Saving..." : saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormBuilderFooter;
